export default "__VITE_ASSET__ro55JJ0C__"